(function () {
  'use strict';

  angular.module('ringbaPortal').component('blockedNumbersTabs', {
    controller: BlockedNumbersTabsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/numbers/blocked-numbers/blocked-numbers-tabs.view.html'
  });

  function BlockedNumbersTabsController() {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {

    }

  }
})();
